export default function loggerColor(action) {
  if (action.type.indexOf("_SUCCESS") !== -1) {
    return "#BADA55"
  }
  if (action.type.indexOf("_REQUEST") !== -1) {
    return "#B19BE8"
  }
  if (action.type.indexOf("_FAILURE") !== -1) {
    return "#F68C80"
  }

  return null
}
